import { StudentCurrentProgramPanelCtrl } from './student-current-program-panel.controller';

angular.module('nv.singleStudent').component('studentCurrentProgramPanel', {
  // tslint:disable-next-line:max-line-length
  template: require('./student-current-program-panel.html'),
  bindings: {
    student: '<',
    currentSchool: '<',
  },
  controller: StudentCurrentProgramPanelCtrl,
});
